<template>
    <b-card class="standardpage reports invoices border-none" :class="headerShow ? 'px-3' : null">
        <!-- selection: {{ $store.state.selection }} -->
        <!-- {{ $route.query.showheader }} -->
        <b-card-header class="px-3 m-0" v-if="headerShow">
            <b-row align-h="between">
                <b-col cols="auto" class="text-sm-left pt-1">
                    <i :class="header.icon" class="mr-1"></i>
                    {{ header.title }} {{ account_id }}
                </b-col>

                <b-col class="text-right">
                    <b-button squared size="sm" variant="outline-primary" @click="back()">
                        <i class="fa fa-chevron-left pr-1"></i>Back
                    </b-button>
                </b-col>
            </b-row>

        </b-card-header>

        <div class="availtable datatable text-left" :class="headerShow ? 'px-3' : null">

            <b-row v-if="item.id" class="mt-3 mb-3">
                <b-col cols="" class="text-left">
                    <b-row no-gutters>
                        <b-col align-self="center" cols="auto"> <img class="logo w-60px inline mr-2"
                                :src="item.banklogo" :alt="item.bankname" :title="item.bankname" /></b-col>
                        <b-col>
                            <div class="strong text-3x">{{ item.accountname }}</div>
                            <div><span class="h6">{{ item.sortno }} - {{ item.accountno }}</span></div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="text-right">
                    <b-row align-h="end mr-2">
                        <b-col cols="auto">
                            <div class="strong text-3x text-right">{{ item.balance | currency("") }}</div>
                            <div><span class="h6">Statement Balance ( {{ $moment.unix(item.balance_at *
                                .001).format("DD MMM YY") }} )</span></div>
                        </b-col>
                        <b-col v-if="unmatched > 0" cols="auto">
                            <div class="strong text-3x">(tba)</div>
                            <div><span class="h6">Balance in BOP</span></div>
                        </b-col>
                        <b-col v-if="unmatched == 0" cols="auto">
                            <div class="text-primary text-3x strong"><i class="fa fa-check-circle pr-2"></i>Matched
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <b-card-body class="py-0 px-0">
                <b-tabs class="gridtabs relative z-0" v-model="action_tab">

                    <b-tab :active="true" @click="bankingsmatch_load(0)">
                        <template #title>
                            <div class="badgecontainer pr-4">
                                <i class="fa fa-unlink text-danger"></i>
                                <!-- Unmatched  -->
                                {{ unmatched_label(item) }}
                                <b-badge v-if="parseFloat(item.unmatched) > 0" id="unmatched" variant="danger"
                                    class="edit_tab mr-1">
                                    {{ parseFloat(item.unmatched) }}</b-badge>
                            </div>
                        </template>
                        <div class="mt-4 mb-4">
                            <!-- tabs here -->
                            <div v-if="unmatched == 0">

                                <b-row align-v="center" class="justify-content-center text-primary h6" no-gutters>
                                    <b-col cols="auto"><i class="fa fa-check-circle fa-2x pr-2"></i></b-col>
                                    <b-col cols="auto">
                                        <span class="text-3x strong">Great job!</span> <br>
                                        <span>You have matched all the transactions for this
                                            account</span></b-col>
                                </b-row>
                                <b-row align-h="center" class="py-2 my-2" no-gutters>
                                    <b-col cols="auto">
                                        <b-row align-v="center" no-gutters
                                            class="border-bottom-secondary-bold border-top-secondary py-2">
                                            <b-col cols="auto" class="mr-5 text-2x">
                                                <span class="strong pr-2 ">Statement Balance</span>
                                                <span>{{ $moment.unix(item.balance_at
                                                    * .001).utc(true).format('DD MMM YY') }}</span>
                                            </b-col>

                                            <b-col>
                                                <span class="text-2x strong text-right">{{ item.balance
                                                    | currency("") }}</span>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>

                            </div>

                            <div v-if="unmatched > 0" class="mb-4">
                                <b-row class="mb-2" v-if="bankingsmatch.filtershow">
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Statement Date" label-size="sm">
                                            <b-input-group>
                                                <daterangepicker size="sm" ref="datetransaction"
                                                    v-model="bankingsmatch.filter.date_at" :opens="'right'"
                                                    :locale-data="locale_data" :ranges="locale_ranges"
                                                    :showDropdowns="true" :linkedCalendars="false"
                                                    :single-date-picker="false">
                                                </daterangepicker>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="bankingsmatch.filter.date_at = {
                                                        startDate: null,
                                                        endDate: null,
                                                    }
                                                        ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Description (LIKE)" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="bankingsmatch.filter.description"
                                                    :debounce="bankingsmatch.debounce" placeholder="Description"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!bankingsmatch.filter.description"
                                                        @click="bankingsmatch.filter.description = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Reference (LIKE)" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="bankingsmatch.filter.reference"
                                                    :debounce="bankingsmatch.debounce" placeholder="Reference"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!bankingsmatch.filter.reference"
                                                        @click="bankingsmatch.filter.reference = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-row>
                                            <!-- <b-col>
                                                <b-form-group label-cols="12" label="Amount (min)" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="bankingsmatch.filter.amount"
                                                            :debounce="bankingsmatch.debounce" placeholder="Amount"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                :disabled="!bankingsmatch.filter.amount"
                                                                @click="bankingsmatch.amount = ''">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group label-cols="12" label="Amount (max)" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="bankingsmatch.filter.amount"
                                                            :debounce="bankingsmatch.debounce" placeholder="Amount"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                :disabled="!bankingsmatch.filter.amount"
                                                                @click="bankingsmatch.amount = ''">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col> -->

                                            <b-col>
                                                <b-form-group label-cols="12" label="Amount (min)" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="bankingsmatch.filter.amount.min"
                                                            :debounce="bankingsmatch.debounce" placeholder="(min)"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                :disabled="!bankingsmatch.filter.amount.min"
                                                                @click="bankingsmatch.filter.amount.min = null">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group label-cols="12" label="Amount (max)" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="bankingsmatch.filter.amount.max"
                                                            :debounce="bankingsmatch.debounce" placeholder="(max)"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                :disabled="!bankingsmatch.filter.amount.max"
                                                                @click="bankingsmatch.filter.amount.max = null">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Status" label-size="sm">
                                            <treeselect id="status" placeholder="Select status..." :clearable="true"
                                                v-model="bankingsmatch.filter.status"
                                                :options="bankingsmatch.filter.status_options"
                                                :disable-branch-nodes="true" :show-count="true"
                                                :default-expand-level="1" />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Statement" label-size="sm">
                                            <treeselect id="Statement" placeholder="Select Statement..."
                                                :clearable="true" v-model="bankingsmatch.filter.statement"
                                                :options="bankingsmatch.filter.statement_options"
                                                :disable-branch-nodes="true" :show-count="true"
                                                :default-expand-level="1" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="px-3 pt-2">
                                    <b-col class="text-right"><span class="strong h6 text-right">Review your
                                            statement lines...</span>
                                    </b-col>
                                    <b-col cols="auto"></b-col>
                                    <b-col class="text-right"><span class="strong h6">...then match with your
                                            transactions in
                                            BOP</span>
                                    </b-col>
                                </b-row>

                                <e-table :refid="bankingsmatch.refid" :busy="bankingsmatch.busy"
                                    :icon="bankingsmatch.icon" :selectmode="'none'"
                                    :showtoolbar="bankingsmatch.showtoolbar" :showfab="false" :showsheets="false"
                                    :showrowcount="true" :showautoadd="false" :showpages="true"
                                    :offset="bankingsmatch.offset" :limit="bankingsmatch.limit"
                                    :page="bankingsmatch.page" :toolbarlibrary="bankingsmatch.toolbarlibrary"
                                    :tools="bankingsmatch.tools" :fields="bankingsmatch.fields"
                                    :items="bankingsmatch.items" :downloaded="bankingsmatch.downloaded"
                                    @click="bankingsmatch_click" @select="bankingsmatch_select"
                                    @load="bankingsmatch_load" />

                                <b-row>
                                    <b-col cols="12" md="5">
                                        <b-form-checkbox class="z-0" switch size="lg" id="isprevious"
                                            v-model="isprevious" name="isprevious" value="true" unchecked-value="false">
                                            <span class="pl-2">Suggest previous entries</span>
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>

                            </div>
                        </div>

                    </b-tab>

                    <b-tab v-if="parseFloat(item.unsent) != -1" @click="bankingssent_load(0)">
                        <template #title>
                            <div class="badgecontainer pr-4">
                                <i class="fa fa-paper-plane text-danger"></i>
                                Unsent
                                <b-badge v-if="parseFloat(item.unsent) > 0" id="unsent" variant="danger"
                                    class="edit_tab mr-1">
                                    {{ parseFloat(item.unsent) }}</b-badge>
                            </div>
                        </template>
                        <div class="my-2">
                            <!-- tabs here -->
                            <div class="mt-4 mb-4" v-if="item.unsent == 0">

                                <b-row align-v="center" class="justify-content-center text-primary h6" no-gutters>
                                    <b-col cols="auto"><i class="fa fa-check-circle fa-2x pr-2"></i></b-col>
                                    <b-col cols="auto">
                                        <span class="text-3x strong">Great job!</span> <br>
                                        <span>All the transactions have been sent to invoicing</span></b-col>
                                </b-row>
                                <b-row align-h="center" class="py-2 my-2" no-gutters>
                                    <b-col cols="auto">
                                        <b-row align-v="center" no-gutters
                                            class="border-bottom-secondary-bold border-top-secondary py-2">
                                            <b-col cols="auto" class="mr-5 text-2x">
                                                <span class="strong pr-2 ">Statement Balance</span>
                                                <span>{{ $moment.unix(item.balance_at
                                                    * .001).utc(true).format('DD MMM YY') }}</span>
                                            </b-col>

                                            <b-col>
                                                <span class="text-2x strong text-right">{{ item.balance
                                                    | currency("") }}</span>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>

                            </div>

                            <div v-if="item.unsent > 0" class="mb-4">
                                <b-row class="mb-2" v-if="bankingssent.filtershow">
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Statement Date" label-size="sm">
                                            <b-input-group>
                                                <daterangepicker size="sm" ref="datetransaction"
                                                    v-model="bankingssent.filter.date_at" :opens="'right'"
                                                    :locale-data="locale_data" :ranges="locale_ranges"
                                                    :showDropdowns="true" :linkedCalendars="false"
                                                    :single-date-picker="false">
                                                </daterangepicker>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="bankingssent.filter.date_at = {
                                                        startDate: null,
                                                        endDate: null,
                                                    }
                                                        ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Description (LIKE)" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="bankingssent.filter.description"
                                                    :debounce="bankingssent.debounce" placeholder="Description"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!bankingssent.filter.description"
                                                        @click="bankingssent.filter.description = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Reference (LIKE)" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="bankingssent.filter.reference"
                                                    :debounce="bankingssent.debounce" placeholder="Reference"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!bankingssent.filter.reference"
                                                        @click="bankingssent.filter.reference = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-row>
                                            <!-- <b-col>
                                                <b-form-group label-cols="12" label="Amount (min)" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="bankingssent.filter.amount"
                                                            :debounce="bankingssent.debounce" placeholder="Amount"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                :disabled="!bankingssent.filter.amount"
                                                                @click="bankingssent.amount = ''">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group label-cols="12" label="Amount (max)" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="bankingssent.filter.amount"
                                                            :debounce="bankingssent.debounce" placeholder="Amount"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                :disabled="!bankingssent.filter.amount"
                                                                @click="bankingssent.amount = ''">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col> -->

                                            <b-col>
                                                <b-form-group label-cols="12" label="Amount (min)" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="bankingssent.filter.amount.min"
                                                            :debounce="bankingssent.debounce" placeholder="(min)"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                :disabled="!bankingssent.filter.amount.min"
                                                                @click="bankingssent.filter.amount.min = null">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group label-cols="12" label="Amount (max)" label-size="sm">
                                                    <b-input-group>
                                                        <b-form-input v-model="bankingssent.filter.amount.max"
                                                            :debounce="bankingssent.debounce" placeholder="(max)"
                                                            trim></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                :disabled="!bankingssent.filter.amount.max"
                                                                @click="bankingssent.filter.amount.max = null">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Status" label-size="sm">
                                            <treeselect id="status" placeholder="Select status..." :clearable="true"
                                                v-model="bankingssent.filter.status"
                                                :options="bankingssent.filter.status_options"
                                                :disable-branch-nodes="true" :show-count="true"
                                                :default-expand-level="1" />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Statement" label-size="sm">
                                            <treeselect id="statement" placeholder="Select statement..."
                                                :clearable="true" v-model="bankingssent.filter.statement"
                                                :options="bankingssent.filter.statement_options"
                                                :disable-branch-nodes="true" :show-count="true"
                                                :default-expand-level="1" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <!-- {{ bankingssent.fields }} -->
                                <b-row v-show="!component">
                                    <b-col>
                                        <!-- :selectmode="'single'" -->
                                        <d-table classdivtable="availtable datatable nested" refid="statement"
                                            :icon="bankingssent.icon" :busy="bankingssent.busy"
                                            :tools="bankingssent.tools" :badges="bankingssent.badges"
                                            :toolbarlibrary="bankingssent.toolbarlibrary" :icons="bankingssent.icons"
                                            :fields="bankingssent.fields" :items="bankingssent.items"
                                            :offset="bankingssent.offset" :limit="bankingssent.limit"
                                            :page="bankingssent.page" @load="bankingssent_load"
                                            @click="bankingssent_click" @select="bankingssent_select"
                                            :tableheight="230">
                                        </d-table>
                                    </b-col>
                                </b-row>
                                <!-- {{ bankingssent.item }} -->
                                <div v-show="component">
                                    <component :is="component" :selection="bankingssent.selected" :config="cconfig"
                                        @discard="bankingssent_click('discard')"></component>
                                </div>

                            </div>
                        </div>

                    </b-tab>

                    <b-tab @click="bankingslines_load(0)">

                        <template #title>
                            <i class="fa fa-file-text-o text-primary mr-1"></i> Statement
                        </template>

                        <!-- <p v-if="bankingslines.bspsummaryshow">
                            <b-row>
                                <b-col>
                                    <b-alert :show="true" variant="secondary">
                                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                            <b-col>
                                                <span class="h6"> Based on the BSP HOT file issue date, the accounting
                                                    period is determined
                                                    as to what accounting period (ap) the tickets have been issued in.
                                                    Use the drop down
                                                    below to select a year and a summary calculation will be displayed.
                                                </span></b-col></b-row>
                                    </b-alert></b-col>
                            </b-row>
                          
                            <b-row class="my-2">

                                <b-col class="text-right">
                                    <b-row no-gutters>
                                        <b-col cols="auto" class="strong text-2x pr-2">BSP Summary for</b-col>
                                        <b-col class="w-90px">
                                            <b-form-group label-cols="12" label="" label-size="sm">

                                                <treeselect placeholder="Select year..." v-model="bspyear"
                                                    :clearable="true" :multiple="false" :options="bspyear_options"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>

                                        </b-col>
                                     
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row class="my-2 w-100pct" no-gutters>
                                <b-col class="text-center">
                                    <span v-html="bspsummary1"> </span>
                                </b-col>
                            </b-row>
                            <d-table classdivtable="availtable datatable nested" refid="statement"
                                :icon="bspsummary.icon" :busy="bspsummary.busy" :tools="bspsummary.tools"
                                :badges="bspsummary.badges" :toolbarlibrary="bspsummary.toolbarlibrary"
                                :icons="bspsummary.icons" :fields="bspsummary.fields" :items="bspsummary.items"
                                :downloaded="bspsummary.downloaded" :showfab="false" :showsheets="false"
                                :showrowcount="true" :showautoadd="false" :showpages="false" :offset="bspsummary.offset"
                                :limit="bspsummary.limit" :page="bspsummary.page" @load="bankingslines_load"
                                @click="bspsummary_click" @select="bspsummary_select">
                            </d-table>
                        </p> -->

                        <b-row class="my-2" v-if="bankingslines.filtershow">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Statement Date" label-size="sm">
                                    <b-input-group>
                                        <daterangepicker size="sm" ref="date_at" v-model="bankingslines.filter.date_at"
                                            :opens="'right'" :locale-data="locale_data" :ranges="locale_ranges"
                                            :showDropdowns="true" :linkedCalendars="false" :single-date-picker="false">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="bankingslines.filter.date_at = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Description (LIKE)" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="bankingslines.filter.description"
                                            :debounce="bankingslines.debounce" placeholder="Description"
                                            trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary"
                                                :disabled="!bankingslines.filter.description"
                                                @click="bankingslines.filter.description = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Reference" label-for="reference" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="bankingslines.filter.reference"
                                            v-model="bankingslines.filter.reference" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste Reference" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary"
                                                @click="bankingslines.filter.reference = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-row>
                                    <b-col>
                                        <b-form-group label-cols="12" label="Amount (min)" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="bankingslines.filter.amount.min"
                                                    :debounce="bankingslines.debounce" placeholder="(min)"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!bankingslines.filter.amount.min"
                                                        @click="bankingslines.filter.amount.min = null">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group label-cols="12" label="Amount (max)" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="bankingslines.filter.amount.max"
                                                    :debounce="bankingslines.debounce" placeholder="(max)"
                                                    trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!bankingslines.filter.amount.max"
                                                        @click="bankingslines.filter.amount.max = null">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Data (LIKE)" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="bankingslines.filter.data"
                                            :debounce="bankingslines.debounce" placeholder="Data" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary"
                                                :disabled="!bankingslines.filter.data"
                                                @click="bankingslines.filter.data = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group v-if="this.item.accountno.includes('LLOYDS')" label-cols="12"
                                    label="Status" label-size="sm">
                                    <treeselect id="status" placeholder="Select status..." :clearable="true"
                                        v-model="bankingslines.filter.status"
                                        :options="bankingslines.filter.status_options_lloyds"
                                        :disable-branch-nodes="true" :show-count="true" :default-expand-level="1" />
                                </b-form-group>
                                <b-form-group v-else label-cols="12" label="Status" label-size="sm">
                                    <treeselect id="status" placeholder="Select status..." :clearable="true"
                                        v-model="bankingslines.filter.status"
                                        :options="bankingslines.filter.status_options" :disable-branch-nodes="true"
                                        :show-count="true" :default-expand-level="1" />
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Statement" label-size="sm">
                                    <treeselect id="statement" placeholder="Select statement..." :clearable="true"
                                        v-model="bankingslines.filter.statement"
                                        :options="bankingslines.filter.statement_options" :disable-branch-nodes="true"
                                        :show-count="true" :default-expand-level="1" />
                                </b-form-group>
                            </b-col>
                        </b-row>


                        <b-row class="mt-2" v-show="!component">
                            <b-col>
                                <!-- :selectmode="'single'" -->
                                <d-table classdivtable="availtable datatable nested" refid="statement"
                                    :icon="bankingslines.icon" :busy="bankingslines.busy" :tools="bankingslines.tools"
                                    :badges="bankingslines.badges" :toolbarlibrary="bankingslines.toolbarlibrary"
                                    :icons="bankingslines.icons" :fields="bankingslines.fields"
                                    :items="bankingslines.items" :downloaded="bankingslines.downloaded"
                                    :offset="bankingslines.offset" :limit="bankingslines.limit"
                                    :page="bankingslines.page" @load="bankingslines_load" @click="bankingslines_click"
                                    @select="bankingslines_select" :tableheight="230">
                                </d-table>
                            </b-col>
                        </b-row>
                        <!-- {{ bankingslines.item }} -->
                        <div v-show="component">
                            <component :is="component" :selection="bankingslines.selected" :config="cconfig"
                                @discard="bankingslines_click('discard')"></component>
                        </div>

                        <b-tabs v-if="bankingslines.edit" class="gridtabs">
                            <b-tab>

                                <template #title>
                                    <i class="fa fa fa-arrows-h text-info ml-1 mr-1"></i>
                                    Statement <span class="text-warning">&lt;edit&gt;</span>
                                    <!-- <span class="text-warning">&lt;{{ selection.length == 0 ? "new"
                                                            : "line edit" }}&gt;</span>&nbsp; -->
                                    <!-- <span class="text-primary">{{ sllines.items.map(o =>
                                                            o.line).indexOf(sllines.item.line) + 1
                                                        }}.</span>-->

                                </template>

                                <p class="py-0 px-0 mb-0">
                                    <b-card class="nopadding my-0">
                                        <b-card-body>
                                            <div class="px-0">
                                                <b-row>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label-cols="12" label="Statement Date"
                                                            label-size="sm">
                                                            <b-input-group>
                                                                <daterangepicker style="width:auto !important" size="sm"
                                                                    ref="date" v-model="bankingslines.datefor_date_at"
                                                                    @update="item_update('datefor_date_at', $event)"
                                                                    :disabled="false" :opens="'right'"
                                                                    :single-date-picker="'single'" :locale-data="{
                                                                        direction: 'ltr',
                                                                        format: 'dd/mm/yy',
                                                                        daysOfWeek: [
                                                                            'Sun',
                                                                            'Mon',
                                                                            'Tue',
                                                                            'Wed',
                                                                            'Thu',
                                                                            'Fri',
                                                                            'Sat',
                                                                        ],
                                                                        monthNames: [
                                                                            'January',
                                                                            'February',
                                                                            'March',
                                                                            'April',
                                                                            'May',
                                                                            'June',
                                                                            'July',
                                                                            'August',
                                                                            'September',
                                                                            'October',
                                                                            'November',
                                                                            'December',
                                                                        ],
                                                                        firstDay: 1,
                                                                    }" :ranges="false" :showDropdowns="true"
                                                                    :linkedCalendars="true" :timePicker="false"
                                                                    :timePicker24Hour="false"
                                                                    :time-picker-increment="1">
                                                                </daterangepicker>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="
                                                                            bankingslines.datefor_date_at = {
                                                                                startDate: null,
                                                                                endDate: null,
                                                                            }
                                                                            ">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Reference" label-for="reference"
                                                            label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text"
                                                                    v-model="bankingslines.item.reference"
                                                                    placeholder="Enter reference"
                                                                    size="sm"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="bankingslines.item.reference = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Payee" label-for="payee" label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text"
                                                                    v-model="bankingslines.item.payee"
                                                                    placeholder="Enter payee" size="sm"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="bankingslines.item.payee = ''">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Amount" label-for="amount" label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text"
                                                                    v-model="bankingslines.item.amount"
                                                                    placeholder="Enter amount" size="sm"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="bankingslines.item.amount = '0.00'">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="12">
                                                        <b-form-group label="Description" label-for="description"
                                                            label-cols="12">
                                                            <b-form-textarea id="description"
                                                                v-model="bankingslines.item.description"
                                                                placeholder="Enter description" rows="3"
                                                                class="smalltextarea"></b-form-textarea>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label="Analysis" label-for="analysis"
                                                            label-cols="12">
                                                            <b-input-group>
                                                                <b-form-input type="text"
                                                                    v-model="bankingslines.item.analysis"
                                                                    placeholder="Enter analysis" size="sm"
                                                                    :disabled="false"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="bankingslines.item.analysis = ''"
                                                                        :disabled="false">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>



                                                </b-row>
                                            </div>
                                        </b-card-body>
                                        <b-card-footer class="no-border p-0 pt-2 mt-2 mx-1">
                                            <b-row no-gutters>
                                                <b-col cols="auto" class="text-left">
                                                    <b-button squared size="sm" variant="primary"
                                                        @click="bankingslines_save([bankingslines.item])"
                                                        v-if="postit_visible">
                                                        <i class="fa fa-check"></i>
                                                        Save It
                                                    </b-button>
                                                </b-col>
                                                <b-col class="text-left ml-2 mt-1">
                                                    <div v-if="busy">
                                                        <i class="fa fa-spinner fa-spin text-primary"></i>
                                                    </div>
                                                    <div v-else>
                                                        <span v-html="message"></span>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-card-footer>
                                    </b-card>
                                </p>
                            </b-tab>

                            <b-tab>

                                <template #title>
                                    <i class="fa fa-file-code-o text-primary mr-1"></i>
                                    Data</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Data" label-for="data" label-cols="12">
                                                <b-form-textarea id="data" v-model="bankingslines.item.data"
                                                    placeholder="Enter data" rows="12" class="smalltextarea courier"
                                                    :disabled="true"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>
                                </p>
                            </b-tab>

                            <b-tab v-if="bankingslines.item.id" @click="bankingslines_matched(bankingslines.item)">

                                <template #title>
                                    <i class="fa fa-link text-primary mr-1"></i>
                                    Matched</template>
                                <p>
                                <div v-if="!bankingslines.matched.id">
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="danger">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> Match entry was not found. Use <i
                                                                class="fa fa-link text-danger mr-1"></i>Match to
                                                            match a transaction.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>
                                </div>
                                <div v-else>
                                    <b-row class="px-3">
                                        <b-col class="text-right"><span class="strong h6 text-right">This statement
                                                line...</span>
                                        </b-col>
                                        <b-col cols="auto"></b-col>
                                        <b-col class="text-right"><span class="strong h6">Has been matched with this
                                                transaction...</span>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="text-right mt-2 mb-2">
                                            <b-button squared size="sm" variant="danger" :disabled="true">
                                                Delete
                                            </b-button>
                                        </b-col>
                                        <b-col class="text-right mt-2 mb-2">
                                            <b-button squared size="sm"
                                                @click="bankingslines_removeandredo([bankingslines.item])"
                                                variant="danger">
                                                Remove & Redo
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <!-- {{ bankingslines.matched }} -->
                                            <i-reconcile v-model="bankingslines.matched">
                                            </i-reconcile>
                                        </b-col>
                                    </b-row>
                                </div>
                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-comments-o text-primary mr-1"></i>
                                    Notes</template>
                                <p class="py-3 px-0">
                                    <b-card class="nopadding my-0">
                                        <b-card-body>
                                            <div class="px-0">
                                                <b-row>
                                                    <b-col cols="12">
                                                        <b-form-group label="Notes" label-for="notes" label-cols="12">
                                                            <b-form-textarea id="notes"
                                                                v-model="bankingslines.item.notes" placeholder="Notes"
                                                                rows="6" class="smalltextarea"></b-form-textarea>
                                                        </b-form-group> </b-col></b-row>
                                            </div>
                                        </b-card-body>
                                        <b-card-footer class="no-border p-0 pt-2 mt-2 mx-1">
                                            <b-row no-gutters>
                                                <b-col cols="auto" class="text-left">
                                                    <b-button squared size="sm" variant="primary"
                                                        @click="bankingslines_save([bankingslines.item])"
                                                        v-if="postit_visible">
                                                        <i class="fa fa-check"></i>
                                                        Save It
                                                    </b-button>
                                                </b-col>
                                                <b-col class="text-left ml-2 mt-1">
                                                    <div v-if="busy">
                                                        <i class="fa fa-spinner fa-spin text-primary"></i>
                                                    </div>
                                                    <div v-else>
                                                        <span v-html="message"></span>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-card-footer>
                                    </b-card>
                                </p>
                            </b-tab>

                            <b-tab v-if="bankingslines.item.id">
                                <template #title>
                                    <i class="fa fa-history text-primary mr-1"></i>Audit
                                </template>
                                <p class="pt-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm"
                                                            v-model="bankingslines.item.created_at" button-only
                                                            label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date"
                                                        v-model="bankingslines.item.created_at" type="text"
                                                        placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="bankingslines.item.created_at = null"
                                                            :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="bankingslines.item.created_by"
                                                        placeholder="" size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="bankingslines.item.created_by = ''"
                                                            :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm"
                                                            v-model="bankingslines.item.updated_at" button-only
                                                            label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date"
                                                        v-model="bankingslines.item.updated_at" type="text"
                                                        placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="bankingslines.item.updated_at = null"
                                                            :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="bankingslines.item.updated_by"
                                                        placeholder="" size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="bankingslines.item.updated_by = ''"
                                                            :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="ID" label-for="id" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="bankingslines.item.id"
                                                        placeholder="" size="sm" :disabled="true"></b-form-input>

                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Statement" label-for="statement" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="bankingslines.item.statement"
                                                        placeholder="" size="sm" :disabled="true"></b-form-input>

                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>
                                </p>
                            </b-tab>

                            <b-tab v-if="hot_data">
                                <template #title>
                                    <i class="fa fa-braille text-dark mr-1"></i>
                                    HOT</template>

                                <b-row class="mt-2" align-h="start" no-gutters>
                                    <b-col class="gridtoolbar" cols="auto">
                                        <b-button :variant="'outline-white'" :size="'sm'" squared
                                            @click="bankingslines_fixit(bankingslines.selected)">
                                            <i :class="'fa fa-bug text-danger'"></i>
                                            Debug & Reset
                                        </b-button>
                                    </b-col>
                                </b-row>

                                <p class="py-1 px-0">
                                    <b-list-group class="courier smalltextarea hover-pointer"
                                        :style="'font-size: 11px !important'">
                                        <b-list-group-item variant="dark" :style="'padding: 0.5rem;padding: 0.5rem;'">
                                            {{ bankingslines.item.reference }}
                                        </b-list-group-item>
                                        <b-list-group-item :style="'padding: 0.5rem;padding: 0.5rem;'"
                                            variant="secondary"
                                            v-for="(item, index) in JSON.parse(bankingslines.item.data).hot"
                                            :key="index">
                                            <span :id="'HOT' + index" @click="bsp_datareference(item)"
                                                v-b-tooltip.hover.righttop.html="bsphelp"
                                                v-html="bsp_pretty(item)"></span>

                                        </b-list-group-item>

                                    </b-list-group>
                                    <small class="text-primary">Click a HOT row to update the tooltip</small>
                                </p>

                            </b-tab>

                        </b-tabs>

                    </b-tab>


                    <b-tab @click="bankingsimports_load(0)">

                        <template #title>
                            <i class="fa fa-upload text-primary mr-1"></i>
                            Imports</template>
                        <p class="pt-3 px-0">
                            <!-- <div v-if="bankingsimports.filtershow">
                            <b-row class="mt-3">
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Statement Date" label-size="sm">
                                        <b-input-group>
                                            <daterangepicker size="sm" ref="date_at"
                                                v-model="bankingsimports.filter.date_at" :opens="'right'"
                                                :locale-data="locale_data" :ranges="locale_ranges"
                                                :linkedCalendars="false" :single-date-picker="false">
                                            </daterangepicker>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary" @click="bankingsimports.filter.date_at = {
        startDate: null,
        endDate: null,
    }
        ">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Reference (LIKE)" label-size="sm">
                                        <b-input-group>
                                            <b-form-input v-model="bankingsimports.filter.reference"
                                                :debounce="bankingsimports.debounce" placeholder="Reference"
                                                trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    :disabled="!bankingsimports.filter.reference"
                                                    @click="bankingsimports.filter.reference = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Description (LIKE)" label-size="sm">
                                        <b-input-group>
                                            <b-form-input v-model="bankingsimports.filter.description"
                                                :debounce="bankingsimports.debounce" placeholder="Description"
                                                trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    :disabled="!bankingsimports.filter.description"
                                                    @click="bankingsimports.filter.description = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Amount" label-size="sm">
                                        <b-input-group>
                                            <b-form-input v-model="bankingsimports.filter.amount" :debounce="debounce"
                                                placeholder="Amount" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    :disabled="!bankingsimports.filter.amount"
                                                    @click="bankingsimports.filter.amount = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div> -->

                            <b-row v-show="bankingsimports.rename" class="mb-3">
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="New Name" label-size="sm">
                                        <b-input-group>
                                            <b-form-input v-model="bankingsimports.newname"
                                                :debounce="bankingsimports.debounce" placeholder="New Name"
                                                trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    :disabled="!bankingsimports.newname"
                                                    @click="bankingsimports.newname = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                                <b-button size="sm" variant="outline-primary"
                                                    @click="bankingsimports_rename()"
                                                    :disabled="bankingsimports.newname == ''">
                                                    <i class="fa fa-check"></i>
                                                    Save It
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                            </b-row>
                            <b-row v-show="!component">
                                <b-col>
                                    <!-- :selectmode="'single'" -->
                                    <d-table classdivtable="availtable datatable nested" refid="statement"
                                        :icon="bankingsimports.icon" :busy="bankingsimports.busy"
                                        :tools="bankingsimports.tools" :badges="bankingsimports.badges"
                                        :toolbarlibrary="bankingsimports.toolbarlibrary" :icons="bankingsimports.icons"
                                        :fields="bankingsimports.fields" :items="bankingsimports.items"
                                        :downloaded="bankingsimports.downloaded" :offset="bankingsimports.offset"
                                        :limit="bankingsimports.limit" :page="bankingsimports.page"
                                        @load="bankingsimports_load" @click="bankingsimports_click"
                                        @select="bankingsimports_select" :tableheight="230">
                                    </d-table>
                                </b-col>
                            </b-row>
                            <!-- {{ bankingsimports.item }} -->
                        <div v-show="component">
                            <component :is="component" :selection="bankingsimports.selected" :config="cconfig"
                                @discard="bankingsimports_click('discard')"></component>
                        </div>
                        </p>
                    </b-tab>

                    <b-tab v-if="this.item.accountno.includes('BSP')" @click="bankingslines_bspsummary()">

                        <template #title>
                            <i class="fa fa-list-alt text-primary mr-1"></i> Summary
                        </template>
                        <!-- v-if="bankingslines.bspsummaryshow" -->
                        <p>
                            <b-row>
                                <b-col>
                                    <b-alert :show="true" variant="secondary">
                                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                            <b-col>
                                                <span class="h6"> Based on the BSP HOT file issue date, the accounting
                                                    period is determined
                                                    as to what accounting period (ap) the tickets have been issued in.
                                                    Use the drop down
                                                    below to select a year and a summary calculation will be displayed.
                                                </span></b-col></b-row>
                                    </b-alert></b-col>
                            </b-row>
                            <!-- <b-row class="my-2">

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Year" label-size="sm">

                                        <treeselect placeholder="Select year..." v-model="bspyear" :clearable="true"
                                            :multiple="false" :options="bspyear_options" :show-count="true"
                                            :flatten-search-results="true" :disable-branch-nodes="true"
                                            :matchKeys="['id']" search-nested>
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-form-group>

                                </b-col>

                            </b-row> -->
                            <b-row class="my-2">

                                <b-col class="text-right">
                                    <b-row no-gutters>
                                        <b-col cols="auto" class="strong text-2x pr-2">BSP Summary for</b-col>
                                        <b-col class="w-90px">
                                            <b-form-group label-cols="12" label="" label-size="sm">

                                                <treeselect placeholder="Select year..." v-model="bspyear"
                                                    :clearable="true" :multiple="false" :options="bspyear_options"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>

                                        </b-col>
                                        <!-- <b-col class="text-right">
                                            <b-button id="clipboard" title="Clipboard" variant="outline-white" squared
                                                size="sm">
                                                <i class="fa fa-clipboard text-primary mr-1"></i><span>Clipboard</span>
                                            </b-button>
                                        </b-col> -->
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row class="my-2 w-100pct" no-gutters>
                                <b-col class="text-center">
                                    <span v-html="bspsummary1"> </span>
                                </b-col>
                            </b-row>
                            <d-table classdivtable="availtable datatable nested" refid="statement"
                                :icon="bspsummary.icon" :busy="bspsummary.busy" :tools="bspsummary.tools"
                                :badges="bspsummary.badges" :toolbarlibrary="bspsummary.toolbarlibrary"
                                :icons="bspsummary.icons" :fields="bspsummary.fields" :items="bspsummary.items"
                                :downloaded="bspsummary.downloaded" :showfab="false" :showsheets="false"
                                :showrowcount="true" :showautoadd="false" :showpages="false" :offset="bspsummary.offset"
                                :limit="bspsummary.limit" :page="bspsummary.page" @load="bankingslines_load"
                                @click="bspsummary_click" @select="bspsummary_select">
                            </d-table>
                        </p>
                    </b-tab>

                    <b-tab v-if="this.item.accountno.includes('XXX')">

                        <template #title>
                            <i class="fa fa-check-square-o text-primary mr-1"></i> Refunds (automatic)
                        </template>

                        <!-- <BankingsRefund /> -->

                    </b-tab>



                    <b-tab>

                        <template #title>
                            <i :class="bankings.icon" class="text-primary mr-1"></i>
                            <span v-if="!item.id" class="text-warning">&lt;new&gt;</span>
                            <span v-if="item.id" class="text-warning">&lt;edit&gt;</span>
                        </template>
                        <p class="pt-3 px-0"> <b-row>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Account Name" label-for="accountname" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.accountname"
                                                placeholder="Enter account name" size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.accountname = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Type" label-for="type" label-cols="12">
                                        <b-input-group class="treeselect_all" style="left:32px; top:-12px">
                                            <i class="fa fa-info-circle text-black" id="statementtype"></i>
                                        </b-input-group>
                                        <b-tooltip target="statementtype" triggers="hover" placement="top">Debits
                                            increase assets and expense accounts. Credits are the opposite and decrease
                                            them. Credits increase liability, revenue, and equity accounts. Debits are
                                            the opposite and decrease them.</b-tooltip>
                                        <treeselect instanceId="type" type="number" v-model="item.type"
                                            :clearable="false" :options="type_options"></treeselect>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Sort Code" label-for="sortno" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.sortno"
                                                placeholder="Enter sort code" size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.sortno = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Account No" label-for="accountno" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.accountno"
                                                placeholder="Enter account no" size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.accountno = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Bank Name" label-for="bankname" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.bankname"
                                                placeholder="Enter Bank Name" size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.bankname = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Bank Logo" label-for="banklogo" label-cols="12">
                                        <treeselect instanceId="banklogo" type="number" v-model="item.banklogo"
                                            :clearable="true" :options="banklogo_options"></treeselect>
                                    </b-form-group>
                                </b-col> -->

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Currency" label-for="currency" label-cols="12" label-size="sm">
                                        <treeselect instanceId="currency" type="number" v-model="item.currency"
                                            :clearable="false" :options="currency_options">
                                        </treeselect>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Open Balance" label-for="open_balance" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.open_balance"
                                                placeholder="Enter open balance" size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.open_balance = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Open At" label-size="sm">
                                        <b-input-group>
                                            <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                v-model="dateopen" @update="item_update('dateopen', $event)"
                                                :disabled="false" :opens="'right'" :single-date-picker="'single'"
                                                :locale-data="{
                                                    direction: 'ltr',
                                                    format: 'dd/mm/yy',
                                                    daysOfWeek: [
                                                        'Sun',
                                                        'Mon',
                                                        'Tue',
                                                        'Wed',
                                                        'Thu',
                                                        'Fri',
                                                        'Sat',
                                                    ],
                                                    monthNames: [
                                                        'January',
                                                        'February',
                                                        'March',
                                                        'April',
                                                        'May',
                                                        'June',
                                                        'July',
                                                        'August',
                                                        'September',
                                                        'October',
                                                        'November',
                                                        'December',
                                                    ],
                                                    firstDay: 1,
                                                }" :ranges="false" :showDropdowns="true" :linkedCalendars="true"
                                                :timePicker="false" :timePicker24Hour="false"
                                                :time-picker-increment="1">
                                            </daterangepicker>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary" @click="
                                                    dateopen = {
                                                        startDate: null,
                                                        endDate: null,
                                                    }
                                                    ">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                                <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Statement At" label-size="sm">
                                        <b-input-group>
                                            <daterangepicker style="width:auto !important" size="sm" ref="datestatement"
                                                v-model="datestatement" :disabled="false" :opens="'right'"
                                                :single-date-picker="'single'" :locale-data="{
                                                    direction: 'ltr',
                                                    format: 'dd/mm/yy',
                                                    daysOfWeek: [
                                                        'Sun',
                                                        'Mon',
                                                        'Tue',
                                                        'Wed',
                                                        'Thu',
                                                        'Fri',
                                                        'Sat',
                                                    ],
                                                    monthNames: [
                                                        'January',
                                                        'February',
                                                        'March',
                                                        'April',
                                                        'May',
                                                        'June',
                                                        'July',
                                                        'August',
                                                        'September',
                                                        'October',
                                                        'November',
                                                        'December',
                                                    ],
                                                    firstDay: 1,
                                                }" :ranges="false" :showDropdowns="true" :linkedCalendars="true"
                                                :timePicker="false" :timePicker24Hour="false"
                                                :time-picker-increment="1">
                                            </daterangepicker>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary" @click="
                                                    datestatement = {
                                                        startDate: null,
                                                        endDate: null,
                                                    }
                                                    ">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col> -->

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Statement Day" label-for="type" label-cols="12">
                                        <treeselect instanceId="statement_day" type="number"
                                            v-model="item.statement_day" :clearable="false"
                                            :options="options_statementday"></treeselect>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Invoicing By" label-for="type" label-cols="12">
                                        <treeselect instanceId="invoicing_by" type="number" v-model="item.invoicing_by"
                                            :clearable="false" :options="options_invoicingby"></treeselect>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Dashboard Position" label-for="position" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="number" :min="0" :max="50" v-model="item.position"
                                                :debounce="bankings.debounce"
                                                placeholder="Dashboard Position"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.position = '0'">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-row>
                                        <b-col>
                                            <b-form-group label="Active?" label-for="isactive" label-cols="12">
                                                <b-form-radio-group id="isactive" v-model="item.isactive" :options="[
                                                    { text: 'Yes', value: 'true' }, { text: 'No', value: 'false' },]"
                                                    buttons button-variant="outline-success" size="sm"
                                                    name="radio-btn-outline"></b-form-radio-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col> <b-form-group label="Dashboard Tile?" label-for="isdashboard"
                                                label-cols="12">
                                                <b-form-radio-group id="isdashboard" v-model="item.isdashboard"
                                                    :options="[
                                                        { text: 'Yes', value: 'true' }, { text: 'No', value: 'false' },]"
                                                    buttons button-variant="outline-success" size="sm"
                                                    name="radio-btn-outline"></b-form-radio-group>
                                            </b-form-group></b-col>

                                    </b-row>

                                </b-col>

                            </b-row>
                            <b-row class="mt-2" no-gutters>
                                <b-col cols="auto" class="text-left">
                                    <b-button squared size="sm" variant="primary" @click="bankings_saveit()">
                                        <i class="fa fa-check"></i>
                                        Save It
                                    </b-button>
                                </b-col>
                                <b-col class="text-left ml-2 mt-1">
                                    <div v-if="busy">
                                        <i class="fa fa-spinner fa-spin text-primary"></i>
                                    </div>
                                    <div v-else>
                                        <span v-html="message"></span>
                                    </div>
                                </b-col>
                            </b-row>
                        </p>

                    </b-tab>

                    <b-tab>

                        <template #title>
                            <i class="fa fa-comments-o text-primary mr-1"></i>
                            Notes</template>
                        <p class="pt-3 px-0">
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group label="Notes" label-for="notes" label-cols="12">
                                        <b-form-textarea id="data" v-model="item.notes" placeholder="Notes" rows="6"
                                            class="smalltextarea"></b-form-textarea>
                                    </b-form-group> </b-col></b-row>
                            <b-row class="mt-2" no-gutters>
                                <b-col cols="auto" class="text-left">
                                    <b-button squared size="sm" variant="primary" @click="bankings_saveit()">
                                        <i class="fa fa-check"></i>
                                        Save It
                                    </b-button>
                                </b-col>
                                <b-col class="text-left ml-2 mt-1">
                                    <div v-if="busy">
                                        <i class="fa fa-spinner fa-spin text-primary"></i>
                                    </div>
                                    <div v-else>
                                        <span v-html="message"></span>
                                    </div>
                                </b-col>
                            </b-row>
                        </p>

                    </b-tab>

                    <b-tab>

                        <template #title>
                            <i class="fa fa-history text-primary mr-1"></i>Audit
                        </template>
                        <p class="pt-3 px-0"> <b-row>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                        <b-input-group>
                                            <b-input-group-prepend>
                                                <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                    label-help="" locale="en-GB" :disabled="true"></b-form-datepicker>
                                            </b-input-group-prepend>
                                            <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                placeholder="YYYY-MM-DD" autocomplete="off"
                                                :disabled="true"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.created_at = null" :disabled="true">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                                                :disabled="true"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.created_by = ''" :disabled="true">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                        <b-input-group>
                                            <b-input-group-prepend>
                                                <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                    label-help="" locale="en-GB" :disabled="true"></b-form-datepicker>
                                            </b-input-group-prepend>
                                            <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                placeholder="YYYY-MM-DD" autocomplete="off"
                                                :disabled="true"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.updated_at = null" :disabled="true">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                                                :disabled="true"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.updated_by = ''" :disabled="true">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="ID" label-for="id" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                :disabled="true"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row></p>
                    </b-tab>
                </b-tabs>

            </b-card-body>

            <b-row class="px-0">
                <b-col>
                    <b-alert :show="errormessage ? true : false" variant="danger">
                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                            <b-col>
                                {{ errormessage }}
                            </b-col></b-row>
                    </b-alert></b-col>
            </b-row>

            <b-card-footer class="mx-1 nopadding mt-2">
                <b-row no-gutters>
                    <!-- <b-col cols="auto" class="text-left">
                        <b-button squared size="sm" variant="primary" @click="bankings_saveit()" v-if="postit_visible">
                            <i class="fa fa-check"></i>
                            Save It
                        </b-button>
                    </b-col> -->

                    <b-col class="text-right" cols="12">
                        <b-button squared size="sm" variant="secondary" @click="back()">
                            <i class="fa fa-chevron-left pr-1"></i>
                            Back
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>

        </div>

        <b-modal id="import-file" ref="modal" v-model="bankingsimports.importshow" centered button-size="sm"
            ok-title="Import It" title="Import Statement" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit">


                <b-form-group label="Name" label-for="name-input" invalid-feedback="Name is required"
                    :state="nameState">
                    <b-input-group>
                        <b-input-group-prepend>
                            <b-button size="sm" title="delete" variant="outline-danger" @click="fileUpload_clear"
                                class="h-28-5px">
                                <i class="fa fa-remove"></i>
                            </b-button>
                        </b-input-group-prepend>
                        <b-form-file id="file-small" size="sm" ref="file-input" :multiple="false" no-drop
                            @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                                " :disabled="fileUpload ? true : false" :state="nameState" required></b-form-file>

                        <!-- <b-form-input id="name-input" v-model="name" :state="nameState" required></b-form-input> -->
                    </b-input-group>
                </b-form-group>

                <div v-if="usesuggested">
                    <b-form-group id="name" label="Suggested Name" label-for="name-input" label-cols="12"
                        invalid-feedback="Name is required" :state="nameState">
                        <b-input-group class="treeselect_all" style="left:95px; top:-15px">
                            <i class="fa fa-info-circle text-dark"></i>
                        </b-input-group>
                        <b-tooltip target="name" triggers="hover" placement="bottom">
                            Overtype the correct end date of the full statement if not today.
                        </b-tooltip>
                        <b-input-group>
                            <b-form-input type="text" v-model="suggestedname"
                                :placeholder="fileUpload ? fileUpload.name : 'No file chosen'" size="sm"
                                :disabled="suggestedname == 'INTERIM_' + item.accountno + '.csv'"></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="name = ''" :disabled="true">
                                    <i class="fa fa-remove"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>

                    <b-form-group label="Options" label-for="importoptions">

                        <!-- <b-form-checkbox-group class="mt-1" v-model="reasontype" :options="options_import"
                        :aria-describedby="ariaDescribedby" name="options_reasontype"></b-form-checkbox-group> -->

                        <b-form-checkbox-group id="importoptions" v-model="importoptions" :options="options_import"
                            size="sm" value-field="id" text-field="label" name="options_import" class="z-0"
                            style="padding-top: 0.2em">
                        </b-form-checkbox-group>

                    </b-form-group>
                </div>

            </form>
        </b-modal>

    </b-card>
</template>

<script>
import gql from "graphql-tag";
//import BankingsRefund from "./BankingsRefund.vue"
import BankingsREMT from "./BankingsREMT";


export default {
    name: "BankingsEdit",
    components: {
        // BankingsRefund,
        BankingsREMT
    },
    async mounted() {
        console.log("BankingsEdit mounted");

        await this.accessdenied();

        try {
            const response = await this.$apollo.query({
                query: gql`
                    query setup_currencies {
                    setup_currencies {
                        id:code
                        label
                    }
                    }
                `,
            });
            this.currency_options = response.data.setup_currencies;
        } catch (error) {
            console.log(error);
        }

        for (var i = 1; i < 31; i++) {
            this.options_statementday.push({ id: i.toString(), label: i.toString() })
        }

        for (var i = parseInt(this.$moment().format('YYYY')); i >= 2024; i--) {
            this.bspyear_options.push({ id: i.toString(), label: i.toString() })
        }
        this.bspyear = this.$moment().format('YYYY')
    },

    data() {
        return {
            header: {
                title: "Banking",
                icon: "fa fa-university text-primary",
                debounce: 500,
            },
            file: {
                name: 0,
                size: 0
            },
            bsphelp: "Click a HOT row to update the tooltip",
            errormessage: "",
            headerShow: false,
            showback: true,
            reconcilemissing: true,
            busy: false,
            account_id: null,
            action_tab: 0,
            state: null,
            posted: false,
            name: '',
            suggestedname: '',
            importoptions: [],
            nameState: null,
            submittedNames: [],
            bspsummary1: null,
            bspyear: this.$moment().format("YYYY"),
            bspyear_options: [],
            isprevious: true,
            balance_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            dateopen: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            datestatement: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            options_import: [
                { id: "usesuggested", label: "Use suggested name?" },
                { id: "full", label: "This is a full statement" },
            ],
            type_options: [
                { id: "credit", label: "Credit" },
                { id: "debit", label: "Debit" },
            ],
            options_invoicingby: [
                { id: "bhold", label: "Bhold" },
                { id: "chold", label: "Chold" },
                { id: "ghold", label: "Ghold" },
                { id: "xhold", label: "Xhold" },
                { id: "zhold", label: "Zhold" },
            ],
            options_statementday: [],
            banklogo_options: [
                { id: "BARCLAYCARD", label: "BARCLAYCARD" },
                { id: "BSP", label: "BSP" },
                { id: "CONFERMAPAY", label: "CONFERMAPAY" },
                { id: "LLOYDS", label: "LLOYDS" },
                { id: "AMEX", label: "AMEX" },
                { id: "BLACKLANE", label: "BLACKLANE" },
            ],
            currency_options: [],
            item: {
                id: null,
                type: "debit",
                accountname: "New Account",
                bankname: null,
                open_at: this.$moment().utc(true).valueOf().toString(),
                currency: "GBP",
                open_balance: "0.00",
                isactive: "true",
                isdashboard: "false"
            },
            bankings: {
                title: "Bank Account",
                icon: "fa fa-university text-primary",
                debounce: 500,
            },
            bankingsmatch: {
                refid: "table_match",
                title: "Match Statement",
                icon: "fa fa-unlink text-danger",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 5,
                filtershow: false,
                filter: {
                    date_at: {
                        startDate: null,
                        endDate: null,
                    },
                    description: "",
                    reference: "",
                    /*amount: [null, null],*/
                    amount: {
                        min: null,
                        max: null,
                    },
                    status: "unmatched",
                    status_options: [
                        {
                            id: "*",
                            label: "All",
                        },
                        {
                            id: "matched",
                            label: "Matched",
                        },
                        {
                            id: "unmatched",
                            label: "Unmatched",
                        },
                    ],
                    statement: null,
                    statement_options: [
                        {
                            id: "*",
                            label: "All",
                        },
                        {
                            id: "imported",
                            label: "Imported",
                        },
                        {
                            id: "manual",
                            label: "Manual",
                        },
                        {
                            id: "feed",
                            label: "Feed",
                        },
                    ],
                },
                toolbarlibrary: [],
                tools: "go,filter",
                fields: [
                    {
                        key: "ritem",
                        label: "Match Statement",
                        type: "ireconcile",
                        class: "text-left w-90pct",
                        clearable: "true",
                    },
                ],
                denied: [],
                items: [],
                downloaded: [],
            },
            bankingssent: {
                refid: "table_publish",
                title: "Unpublished lines",
                icon: "fa fa-paper-plane text-danger",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                filtershow: false,
                filter: {
                    date_at: {
                        startDate: null,
                        endDate: null,
                    },
                    description: "",
                    reference: "",
                    amount: {
                        min: null,
                        max: null,
                    },
                    status: "unsent",
                    status_options: [
                        {
                            id: "*",
                            label: "All",
                        },
                        {
                            id: "published",
                            label: "Published",
                        },
                        {
                            id: "unsent",
                            label: "Unsent",
                        },
                    ],
                    statement: null,
                    statement_options: [
                        {
                            id: "*",
                            label: "All",
                        },
                        {
                            id: "imported",
                            label: "Imported",
                        },
                        {
                            id: "manual",
                            label: "Manual",
                        },
                        {
                            id: "feed",
                            label: "Feed",
                        },
                    ],
                },
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-paper-plane text-dark",
                        position: "toolbar",
                        action: "invoicing",
                        label: "Send to Charges",
                        component: {
                            name: "",
                        },
                    },
                ],
                tools: "go,filter,invoicing",
                fields: [
                    // {
                    //     key: "selected",
                    //     label: "...",
                    //     class: "text-center",
                    // },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "date_at",
                        label: "Date",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "type",
                        label: "Type",
                        class: "text-center",
                        sortable: true,
                    },
                    {
                        key: "description",
                        label: "Description",
                        class: "text-left",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 50) {
                                    result = result.slice(0, 47) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "reference",
                        label: "Reference",
                        class: "text-center",
                        sortable: true,
                    },
                    {
                        key: "payee",
                        label: "Payee",
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 30) {
                                    result = result.slice(0, 27) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "spent",
                        label: "Spent",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "received",
                        label: "Received",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "balance",
                        label: "Balance",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "statement",
                        label: "Statement",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "refer",
                        label: "Document",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                        class: "text-center",
                    },

                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    // {
                    //     key: "actions",
                    //     label: "Actions",
                    //     class: "actions w-110px",
                    // },
                ],
                badges: [
                    {
                        key: "type",
                        type: "badge",
                        debit: "danger",
                        credit: "primary",
                    },
                    {
                        key: "status",
                        type: "badge",
                        unmatched: "danger",
                        matched: "primary",
                    },
                    {
                        key: "statement",
                        type: "pill",
                        class: "secondary",
                    },

                ],
                denied: [],
                items: [],
                downloaded: [],
            },
            bankingslines: {
                busy: false,
                debounce: 500,
                title: "Bank Feeds",
                icon: "fa fa-file-text-o text-primary",
                page: 1,
                offset: 0,
                limit: 15,
                toolbarlibrary: [
                    /*  {
                          type: "button",
                          size: "sm",
                          variant: "outline-white",
                          squared: "squared",
                          icon: "fa fa-check-square-o text-purple",
                          position: "toolbar",
                          action: "bspsummary",
                          label: "BSP Summary",
                          component: {
                              name: "",
                          },
                      },*/
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-cogs text-orange",
                        position: "toolbar",
                        action: "bsp",
                        label: "BSP",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-database text-orange",
                        position: "toolbar",
                        action: "repository",
                        label: "Repository",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-chain text-primary",
                        position: "toolbar",
                        action: "match",
                        label: "Match",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-chain-broken text-danger",
                        position: "toolbar",
                        action: "unmatched",
                        label: "Unmatched",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-question-circle-o text-primary",
                        position: "toolbar",
                        action: "rematch",
                        label: "Rematch",
                        component: {
                            name: "",
                        },
                    },

                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-paper-plane text-dark",
                        position: "toolbar",
                        action: "invoicing",
                        label: "Send to Charges",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-envelope text-warning",
                        position: "toolbar",
                        action: "email",
                        label: "Email",
                        component: {
                            name: "",
                        },
                    },
                    // {
                    //     type: "button",
                    //     size: "sm",
                    //     variant: "outline-white",
                    //     squared: "squared",
                    //     icon: "fa fa-check-square-o text-primary",
                    //     position: "toolbar",
                    //     action: "refunds",
                    //     label: "Refunds",
                    //     component: {
                    //         name: "BankingsRefund",
                    //     },
                    // },
                ],
                edit: false,
                tools: "go,filter,export,add,edit,deleteconfirm,match,unmatched,rematch",
                bspsummaryshow: false,
                filtershow: false,
                filter: {
                    date_at: {
                        startDate: null,
                        endDate: null,
                    },
                    amount: {
                        min: null,
                        max: null,
                    },
                    reference: [],
                    description: null,
                    data: null,
                    status: null,
                    status_options: [
                        {
                            id: "*",
                            label: "All",
                        },
                        {
                            id: "matched",
                            label: "Matched",
                        },
                        {
                            id: "unmatched",
                            label: "Unmatched",
                        },
                    ],
                    status_options_lloyds: [
                        {
                            id: "*",
                            label: "All",
                        },
                        {
                            id: "matched",
                            label: "Posted",
                        },
                        {
                            id: "unmatched",
                            label: "Unposted",
                        },
                    ],
                    statement: null,
                    statement_options: [
                        {
                            id: "*",
                            label: "All",
                        },
                        {
                            id: "imported",
                            label: "Imported",
                        },
                        {
                            id: "manual",
                            label: "Manual",
                        },
                        {
                            id: "feed",
                            label: "Feed",
                        },
                    ],
                },
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "date_at",
                        label: "Date",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "type",
                        label: "Type",
                        class: "text-center",
                        sortable: true,
                    },
                    {
                        key: "description",
                        label: "Description",
                        class: "text-left",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 50) {
                                    result = result.slice(0, 47) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "reference",
                        label: "Reference",
                        class: "text-center",
                        sortable: true,
                    },
                    {
                        key: "payee",
                        label: "Payee",
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 30) {
                                    result = result.slice(0, 27) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "spent",
                        label: "Spent",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "received",
                        label: "Received",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "balance",
                        label: "Balance",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "statement",
                        label: "Statement",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "refer",
                        label: "Document",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                        class: "text-center",
                    },

                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                badges: [
                    {
                        key: "type",
                        type: "badge",
                        debit: "danger",
                        credit: "primary",
                    },
                    {
                        key: "status",
                        type: "badge",
                        unmatched: "danger",
                        matched: "primary",
                    },
                    {
                        key: "statement",
                        type: "pill",
                        class: "secondary",
                    },

                ],
                denied: [],
                items: [],
                selected: [],
                downloaded: [],
                matched: {},
                item: {},
                datefor_date_at: {
                    startDate: null,
                    endDate: null,
                },

            },
            bankingsimports: {
                busy: false,
                filter: false,
                debounce: 500,
                title: "Imported",
                icon: "fa fa-upload text-primary",
                page: 1,
                offset: 0,
                limit: 15,
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-repeat text-primary",
                        position: "toolbar",
                        action: "redo",
                        label: "Redo",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-database text-primary",
                        position: "toolbar",
                        action: "check",
                        label: "OnStatement?",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-clock-o text-orange",
                        position: "toolbar",
                        action: "pending",
                        label: "Pending",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-list-ol text-purple",
                        position: "toolbar",
                        action: "reorder",
                        label: "Reorder",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa fa-floppy-o text-primary",
                        position: "toolbar,actions",
                        action: "saveas",
                        label: "Save As",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-plus-circle text-orange",
                        position: "toolbar",
                        action: "remt",
                        label: "REMT",
                        component: {
                            name: "BankingsREMT",
                        },
                    },

                ],
                newname: "",
                rename: false,
                edit: false,
                tools: "go,filter,import,download,deleteconfirm,saveas,remt,pending",
                importshow: false,
                filtershow: false,
                // filter: {
                //     date_at: {
                //         startDate: null,
                //         endDate: null,
                //     },
                //     reference: null,
                //     description: null,
                //     amount: null,
                // },
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },

                    {
                        key: "url",
                        label: "Statement",
                        class: "text-center",
                        sortable: true,
                    },
                    {
                        key: "size",
                        label: "Size",
                        class: "text-center",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$options.filters.formatSize(value);
                            }
                            return result;
                        },
                    },
                    {
                        key: "lines",
                        label: "Lines",
                        class: "text-center",
                        sortable: true,
                        type: "int",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "imported",
                        label: "Imported",
                        class: "text-center",
                        sortable: true,
                        type: "int",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "unmatched",
                        label: "Unmatched",
                        class: "text-center",
                        sortable: true,
                        type: "int",

                    },
                    {
                        key: "start_at",
                        label: "Start At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "end_at",
                        label: "End At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "type",
                        label: "Type",
                        class: "text-center",
                        sortable: true,
                    },
                    {
                        key: "created_by",
                        label: "Created By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "created_at",
                        label: "Created At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },

                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                badges: [
                    {
                        key: "url",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "lines",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "unmatched",
                        type: "pill",
                        class: "danger",
                    },
                    {
                        key: "imported",
                        type: "pill",
                        class: "primary",
                    },
                    {
                        key: "type",
                        type: "badge",
                        full: "primary",
                        interim: "warning",
                        pending: "warning",
                        loading: "danger"
                    },
                ],
                items: [],
                selected: [],
                downloaded: [],
                item: {},

            },
            bspsummary: {
                busy: false,
                icon: "fa fa-ticket text-orange",
                title: "Summary",
                tools: "go,download,clipboard",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-35px",
                    },
                    {
                        key: "label",
                        label: "",
                        class: "text-right",
                        sortable: true,
                    },
                    {
                        key: "ap_1",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_2",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_3",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_4",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_5",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_6",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_7",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_8",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_9",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_10",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_11",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                    {
                        key: "ap_12",
                        label: "",
                        class: "text-right",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = parseFloat(value).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }
                            return result;
                        },
                    },
                ],
                items: [],
                select: [],
                download: [],
            }
        };
    },
    watch: {
        "$store.state.selection": {
            immediate: true,
            async handler(newVal, oldVal) {
                console.log('$store.state.selection', newVal)
                this.selection = [this.$store.state.selection[0]]
                this.headerShow = this.$route.query.showheader == 'true' ? true : false
                this.action_tab = 0
            }
        },

        "bankingslines.filter.date_at": {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.bankingslines_load(0)
            }
        },
        "bankingslines.filter.description": {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.bankingslines_load(0)
            }
        },
        "bankingslines.filter.data": {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.bankingslines_load(0)
            }
        },
        "bankingslines.filter.reference": {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.bankingslines_load(0)
            }
        },
        "bankingslines.filter.amount": {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                await this.bankingslines_load(0)
            }
        },
        "bankingslines.filter.statement": {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.bankingslines_load(0)
            }
        },
        "bankingslines.filter.status": {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.bankingslines_load(0)
            }
        },
        fileUpload: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                if (newVal) {

                    this.file.name = newVal.name;
                    this.file.size = newVal.size;

                    if (this.usesuggested) {
                        this.suggestedname = this.$moment().format('YYYY-MM-DD')
                        if (this.importoptions.includes('full')) {
                            this.suggestedname += "_FULL" + "_" + this.item.accountno
                        } else {
                            this.suggestedname = "INTERIM" + "_" + this.item.accountno
                        }
                        this.suggestedname += ".csv"
                    }

                } else {
                    this.file.name = null;
                    this.file.size = 0;
                }
            },
        },
        importoptions: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    if (this.file.name) {
                        if (this.usesuggested) {
                            this.suggestedname = this.$moment().format('YYYY-MM-DD')
                            if (this.importoptions.includes('full')) {
                                this.suggestedname += "_FULL" + "_" + this.item.accountno
                            } else {
                                this.suggestedname = "INTERIM" + "_" + this.item.accountno
                            }
                            this.suggestedname += ".csv"
                        }
                    }
                }
            }
        },
        bspyear: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    await this.bankingslines_bspsummary()
                } else {
                    this.bspsummary.items = []
                }
            }
        },
        action_tab: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.errormessage = ""
                    this.component = null
                }
            }
        }
    },
    computed: {
        readonly() {
            return true;
        },
        unmatched() {
            if (this.item) {
                return parseFloat(this.item.unmatched)
            } else {
                return 0
            }
        },
        postit_visible() {
            if (this.user.permissions.includes('bankings.save') && this.action_tab != 0) {
                return true
            } else {
                return false
            }
        },
        postit_enabled() {
            if (this.user.permissions.includes('bankings.save')) {
                return true
            } else {
                return false
            }
        },

        hot_data() {
            if (this.bankingslines.item.data) {
                return JSON.parse(this.bankingslines.item.data).hot
            }
        },

        usesuggested() {
            if (this.item.accountno == "BLACKLANE") {
                this.importoptions = ['usesuggested', 'full']
                return true
            } else if (this.item.accountno == "WBAMEX") {
                this.importoptions = ['usesuggested']
                return true
            } else if (this.item.accountno == "SVPCONF" || this.item.accountno == "SVPCONFU" || this.item.accountno == "BCARDCONF") {
                this.importoptions = ['usesuggested']
                return true
            } else {
                this.importoptions = []
                return false
            }
        }
    },
    methods: {
        accessdenied() {

            this.bankingslines.denied = [];
            if (this.user.permissions.includes("systems.development") || (this.user.initials == "MR" || this.user.initials == "JA")) {
                this.bankingsimports.tools = "go,filter,import,download,rename,deleteconfirm,redo,check,pending,reorder,saveas,remt"
            }
        },

        async load() {
            this.bankingsmatch.items = []
            this.bankingssent.items = []
            this.bankingslines.items = []

            await this.bankings_load()
            await this.bankingsmatch_load(0)

        },

        unmatched_label(account) {
            if (account.accountno.includes('LLOYDS')) {
                return 'Unposted'
            } else if (account.accountno.includes('BSP')) {
                return 'Blackhole'
            } else {
                return 'Inventory'
            }
        },

        async bankings_load() {
            if (!this.idselected) { return }

            let variables = {
                id: this.idselected
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankings(
                            $id: String  
                        ) {
                            bankings(
                            id: $id            
                        ) {
                            id
                            type
                            sortno
                            accountno
                            accountname                    
                            bankname
                            banklogo  
                            currency
                            balance
                            balance_at    
                            open_balance
                            open_at
                            router_to 
                            isactive   
                            isdashboard   
                            position
                            unmatched
                            unsent
                            metadata
                            notes
                            statement_day
                            invoicing_by
                            created_at
                            created_by
                            updated_at
                            updated_by        
                        }
                        }
                    `,
                    variables,
                });

                if (response.data.bankings.length > 0) {
                    this.item = response.data.bankings[0];

                    if (this.item.open_at) {
                        let v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
                        if (this.item.open_at != 'NaN') {
                            v = this.$moment.unix(this.item.open_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                        }
                        this.dateopen = { startDate: v, endDate: v }
                    }


                    if (this.item.accountno.includes('LLOYDS') == true) {
                        this.bankingslines.tools = "go,filter,download,add,edit,deleteconfirm,match,unmatched,rematch"
                    }
                    if (this.item.accountno.includes('BSP') == true) {
                        this.bankingslines.tools = "go,filter,download,add,edit,deleteconfirm,match,unmatched,rematch,email,repository,bsp,bspsummary"
                    }
                    if (this.item.accountno.includes('CONF') == true) {
                        this.bankingslines.tools = "go,filter,download,add,edit,deleteconfirm,match,unmatched,rematch,invoicing"
                    }
                    if (this.item.accountno.includes('BLACKLANE') == true) {
                        this.bankingslines.tools = "go,filter,download,add,edit,deleteconfirm,match,unmatched,rematch,invoicing"
                    }
                    if (this.item.accountno.includes('WBAMEX') == true) {
                        this.bankingslines.tools = "go,filter,download,add,edit,deleteconfirm,match,unmatched,rematch,invoicing"
                    }


                }
            } catch (error) {
                console.log(error);
            }

        },
        async item_update(a, v) {
            console.log(a, v)

            // let state = this.segments;
            switch (a) {
                case "dateopen":
                    this.item.open_at = this.$moment(v.startDate).utc(true).valueOf().toString()
                    break;
                case "datefor_date_at":
                    this.bankingslines.item.date_at = this.$moment(v.startDate).utc(true).valueOf().toString()
                    break;
            }
        },
        async bankings_saveit() {
            this.busy = true;

            console.log(this.account_tab)

            let variables = { rows: [this.cleanit(this.item)] };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation bankings_save(
                        $rows: [Banking_input]               
                    ) {
                        bankings_save(rows: $rows) {
                        id
                        }
                    }
                    `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async bankingsmatch_load(offset, limit, page) {
            if (!this.item.id) { return }

            let state = this.bankingsmatch;

            state.busy = true;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            let variables = {
                offset,
                limit: limit ? limit : state.limit,
                status: state.filter.status,
                statement: state.filter.statement,
                account_id: this.item.id,
                date_at: state.filter.date_at.startDate ? [state.filter.date_at.startDate, state.filter.date_at.endDate] : null,
                description: state.filter.description,
                reference: state.filter.reference,
                amount: state.filter.amount.min ? [state.filter.amount.min, state.filter.amount.max] : null,

            };
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankingslines (
                            $offset: Int
                            $limit: Int   
                            $status: String     
                            $statement: String          
                            $account_id: String
                            $description:String,
                            $reference:String,
                            $amount:[String], 
                            $date_at:[String]
                        ) {
                            bankingslines (
                            offset: $offset
                            limit: $limit
                            status: $status
                            statement: $statement
                            account_id: $account_id     
                            description:$description,
                            reference:$reference,
                            amount:$amount, 
                            date_at:$date_at                           
                        ) {
                            id
                            date_at
                            reference
                            payee
                            description
                            amount
                            spent
                            received
                            statement
                            status
                            type
                            account_id
                            accountno
                            unmatched
                            created_at
                            created_by
                            updated_at
                            updated_by
                            rows
                        }
                        }
                    `,
                    variables,
                });

                if (limit == 0) {
                    state.selected = response.data.bankingslines
                } else {
                    state.items = []
                    // state.items = response.data.bankingslines.map(o => ({ ...o, metadata: this.item.metadata }))
                    state.items = response.data.bankingslines.map(o => ({ ...o }))
                }
                this.item.unmatched = state.items[0].unmatched

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async bankingsmatch_click(a, ss) {
            console.log("bankingsmatch_click", a, ss);

            let state = this.bankingsmatch;

            switch (a) {
                case "selectall":
                    break;
                case "filter":
                    state.filtershow = !state.filtershow;
                    break;
                case "discard":
                    this.component = null
                    break;
                case "go":
                    await this.bankingsmatch_load(0)
                    break;
                case "add":
                case "edit":
                    break;

                case "back":
                    this.$router.go(-1)
                    break;
            }
        },
        async bankingsmatch_select(ss, tools) {

            let state = this.bankingsmatch;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "export", "add", "invoicing"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async bankingssent_load(offset, limit, page) {
            if (!this.item.id) { return }

            let state = this.bankingssent;

            state.busy = true;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            let variables = {
                offset,
                limit: limit ? limit : state.limit,
                status: "unsent",
                statement: state.filter.statement,
                account_id: this.item.id,
                date_at: state.filter.date_at.startDate ? [state.filter.date_at.startDate, state.filter.date_at.endDate] : null,
                description: state.filter.description,
                reference: state.filter.reference,
                amount: state.filter.amount.min ? [state.filter.amount.min, state.filter.amount.max] : null,


            };
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankingslines (
                            $offset: Int
                            $limit: Int   
                            $status: String     
                            $statement: String          
                            $account_id: String
                            $description:String,
                            $reference:String,
                            $amount:[String], 
                            $date_at:[String]
                        ) {
                            bankingslines (
                            offset: $offset
                            limit: $limit
                            status: $status
                            statement: $statement
                            account_id: $account_id     
                            description:$description,
                            reference:$reference,
                            amount:$amount, 
                            date_at:$date_at                           
                        ) {
                            id
                            date_at
                            reference
                            payee
                            description
                            amount
                            spent
                            received
                            statement
                            refer
                            status
                            type
                            account_id
                            unmatched
                            created_at
                            created_by
                            updated_at
                            updated_by
                            rows
                        }
                        }
                    `,
                    variables,
                });

                if (limit == 0) {
                    state.selected = response.data.bankingslines
                } else {
                    state.items = []
                    state.items = response.data.bankingslines
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async bankingssent_click(a, ss) {

            let state = this.bankingssent;

            switch (a) {
                case "selectall":
                    break;
                case "filter":
                    state.filtershow = !state.filtershow;
                    break;
                case "discard":
                    this.component = null
                    break;
                case "go":
                    await this.bankingssent_load(0)
                    break;

                case "invoicing":
                    state.busy = true
                    await this.bankingslines_invoicing(ss)
                    await this.bankingssent_load(0)
                    await this.load()
                    state.busy = false
                    break;

                case "back":
                    this.$router.go(-1)
                    break;
            }
        },
        async bankingssent_select(ss, tools) {

            let state = this.bankingssent;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "invoicing"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                // enabled = ["edit"];
                // enabled.forEach(function (action, index) {
                //     tool = tools.find((o) => o.action == action);
                //     if (tool) {
                //         tool.disabled = ss.length == 1 ? false : true;
                //     }
                // });
                // > 1
                // enabled = ["deleteconfirm"];
                // enabled.forEach(function (action, index) {
                //     tool = tools.find((o) => o.action == action);
                //     if (tool) {
                //         tool.disabled = ss.length > 0 ? false : true;
                //     }
                // });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async bankingslines_load(offset, limit, page) {

            if (!this.item.id) { return }

            let state = this.bankingslines;

            state.bspsummaryshow = false
            this.bspyear = null

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.edit = false
            if (limit != 0) { state.busy = true; }

            let variables = {
                offset: state.offset,
                limit: state.limit,
                account_id: this.item.id,
                date_at: state.filter.date_at.startDate ? [state.filter.date_at.startDate, state.filter.date_at.endDate] : null,
                reference: state.filter.reference.length > 0 ? state.filter.reference.join(",") : null,
                amount: state.filter.amount.min ? [state.filter.amount.min, state.filter.amount.max] : null,
                description: state.filter.description,
                data: state.filter.data,
                status: state.filter.status,
                statement: state.filter.statement,
            };
            console.log("bankingslines_load variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankingslines (
                            $offset: Int
                            $limit: Int         
                            $account_id: String
                            $date_at: [String]
                            $reference: String
                            $amount: [String]
                            $description: String
                            $data: String
                            $status: String
                            $statement: String
                        ) {
                            bankingslines (
                            offset: $offset
                            limit: $limit
                            account_id: $account_id  
                            date_at: $date_at  
                            reference: $reference  
                            amount: $amount  
                            description: $description   
                            data: $data    
                            status: $status  
                            statement: $statement                              
                        ) {
                            id
                            type
                            date_at
                            description
                            payee
                            reference
                            amount
                            spent
                            received
                            balance
                            statement
                            status
                            refer
                            data
                            notes
                            analysis
                            account_id
                            accountno
                            unmatched
                            created_at
                            created_by
                            updated_by
                            updated_at
                            rows
                        }
                        }
                    `,
                    variables,
                });

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.bankingslines
                } else {
                    state.items = []
                    state.items = response.data.bankingslines;

                    this.item.unmatched = state.items[0].unmatched
                }

            } catch (error) {
                console.log(error);
            }
            this.message = ""
            state.edit = false
            state.busy = false;
        },
        async bankingslines_matched(item) {

            this.bankingslines.matched = {}
            let variables = {
                id: item.id
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankingslines (     
                            $id: String
                        ) {
                            bankingslines (
                            id: $id                            
                        ) {
                            id
                            type
                            date_at
                            description
                            payee
                            reference
                            amount
                            spent
                            received
                            balance
                            statement
                            status
                            data
                            notes
                            analysis
                            account_id
                            accountno
                            unmatched
                            matched {
                                id
                                type
                                bankinglines_id
                                link_id
                                link_type
                                date_at
                                transfer
                                ref
                                who
                                what
                                why
                                vat
                                fee
                                adjust
                                amount
                                link
                                deleted
                            }
                            created_at
                            created_by
                            updated_by
                            updated_at
                            rows
                        }
                        }
                    `,
                    variables,
                });
                if (response.data.bankingslines.length > 0) {
                    if (response.data.bankingslines[0].matched.length > 0) {
                        this.bankingslines.matched = response.data.bankingslines[0]
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        async bankingslines_click(a, ss) {
            console.log('bankingslines_click', a)

            let state = this.bankingslines;
            state.matched = {}

            switch (a) {
                case "selectall":
                    break;
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.bankingslines_load(0);
                    break;
                case "filter":
                    state.filtershow = !state.filtershow;
                    break;
                case "discard":
                    this.component = null
                    await this.bankingslines_load(0)
                    break;
                case "go":
                    await this.bankingslines_load(0)
                    break;
                case "add":
                    state.item = {
                        amount: "0",
                        account_id: this.item.id
                    }
                    state.edit = !state.edit
                    break;
                case "edit":
                    state.edit = !state.edit
                    break;
                case "delete":
                    await this.bankingslines_delete(ss)
                    break;

                case "bsp":
                    if (this.item.accountname.includes('BSP')) {
                        await this.bankingslines_bsp(ss)
                    }
                    break;

                case "bspsummary":
                    if (this.item.accountname.includes('BSP')) {
                        state.bspsummaryshow = !state.bspsummaryshow
                    }
                    break;

                case "repository":
                    if (this.item.accountname.includes('BSP')) {
                        await this.bankingslines_repository(ss)
                    }
                    break;

                case "email":
                    if (this.item.accountname.includes('BSP')) {
                        await this.bankingslines_email(ss)
                    }
                    break;

                case "invoicing":
                    await this.bankingslines_invoicing(ss)
                    break;

                case "match":
                    await this.bankingslines_match(ss)
                    break;

                case "rematch":
                    await this.bankingslines_rematch(ss)
                    break;

                case "unmatched":
                    state.filter.status = "unmatched"
                    break;



            }
        },
        async bankingslines_select(ss, tools) {

            let state = this.bankingslines;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "clipboard", "download", "add", "match", "unmatched", "rematch", "repository", "bsp", "bspsummary", "invoicing", "email"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "ticket"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });

                if (state.selected.length > 0) {
                    state.item = state.selected[0]  // WHAT YOU SELECTED

                    let v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
                    if (state.item.date_at != 'NaN') {
                        v = this.$moment.unix(state.item.date_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    }
                    state.datefor_date_at = { startDate: v, endDate: v }
                } else {
                    state.item = {}
                    state.edit = false
                }
            }
        },
        async bankingslines_save(ss) {

            let variables = {
                rows: this.cleanit(ss),
            };
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation bankingslines_save(
                        $rows: [BankingLine_input]               
                    ) {
                        bankingslines_save(rows: $rows) {
                        id
                        }
                    }
                    `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            await this.bankingslines_load(0);

        },
        async bankingslines_delete(ss) {

            let state = this.bankingslines;
            state.busy = true

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_delete($rows: [BankingLine_input]) {
                            bankingslines_delete(rows: $rows) {
                            id
                        }
                    }
                    `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            state.busy = false
            await this.bankingslines_load(0);
        },

        async bankingslines_bsp(ss) {

            let state = this.bankingslines

            if (await this.$bvModal.msgBoxConfirm('BSP statement data is reprocessed to correct ticket images.', {
                title: 'Please confirm you want to reprocess?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                state.busy = true

                let variables = {
                    account_id: this.item.id,
                    // options: 'redorfnd',
                    rows: this.cleanit(ss)
                };
                console.log(variables)
                try {
                    const response = await this.$apollo.mutate({
                        mutation: gql`
                            mutation bankingslines_fixit(
                                $rows: [BankingLine_input],
                                $options:String,
                                $account_id:String              
                            ) {
                                bankingslines_fixit (rows: $rows, options:$options, account_id:$account_id) {
                                    id
                                }
                            }
                            `,
                        variables,
                    });
                    this.message = "<span class='text-primary'>Saved it.</span>";
                } catch (error) {
                    this.message = "<span class='text-danger'>" + error.message + "</span>";
                }
                state.busy = false
                await this.bankingslines_load(0);

            } else {
                state.busy = false
            }
            await this.bankingslines_load(0);

        },
        async bankingslines_repository(ss) {

            if (await this.$bvModal.msgBoxConfirm('BSP HOT file statement data is used to repair/inject data into the Repository.', {
                title: 'Please confirm you want to publish the selected rows to the Repository?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                this.bankingslines.busy = true

                let variables = {
                    account_id: this.item.id,
                    rows: this.cleanit(ss)
                };
                // DO SOMETHING
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation bankingslines_repository ($rows:[BankingLine_input], $account_id:String) {
                        bankingslines_repository(rows: $rows, account_id: $account_id) {
                            id
                            ticketno
                        }
                    }
                    `,
                    variables,
                });

                // variables = {
                //     account_id: this.account.id,
                // }
                // response = await this.$apollo.mutate({
                //     mutation: gql`
                //         mutation bankingslines_match ($account_id:String) {
                //             bankingslines_match (account_id: $account_id) 
                //         }
                //         `,
                //     variables,
                // });
                this.bankingslines.busy = false

            } else {
                this.bankingslines.busy = false
            }
            await this.bankingslines_load(0);

        },

        async bankingslines_email(ss, tools) {

            console.log("notifications_email", ss);

            let state = this.bankingslines;

            if (await this.$bvModal.msgBoxConfirm('Email BAS?', {
                title: 'Please confirm you want to email the BAS team with outstanding "blackhole" tickets?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                state.busy = true

                try {
                    const response = await this.$apollo.query({
                        query: gql`
                            query ticketsblackhole_email{
                                ticketsblackhole_email 
                                }
                    `,
                    });
                } catch (error) {
                    console.log(error);
                }

                state.busy = false
            } else {
                state.busy = false
            }
            await this.bankingslines_load(0);

        },

        async bankingslines_match(ss) {

            if (await this.$bvModal.msgBoxConfirm('Data is automatically matched against the Backoffice.', {
                title: 'Please confirm you want to match this statement?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                this.bankingslines.busy = true

                let variables = {
                    account_id: this.item.id,
                }
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_match ($account_id:String) {
                            bankingslines_match (account_id: $account_id) 
                        }
                        `,
                    variables,
                });

                this.bankingslines.busy = false
            } else {
                this.bankingslines.busy = false
            }

            await this.bankingslines_load(0);

        },
        async bankingslines_rematch(ss) {

            if (await this.$bvModal.msgBoxConfirm('Data is automatically matched against the Backoffice.', {
                title: 'Please confirm you want to rematch this statement?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                this.bankingslines.busy = true

                let variables = {
                    account_id: this.item.id,
                }
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_rematch ($account_id:String) {
                            bankingslines_rematch (account_id: $account_id) {
                                id
                            }
                        }
                        `,
                    variables,
                });

                this.bankingslines.busy = false
            } else {
                this.bankingslines.busy = false
            }

            await this.bankingslines_load(0);

        },

        // async bankingslines_remt(ss) {

        // if (await this.$bvModal.msgBoxConfirm('Data is automatically matched against the Backoffice.', {
        //     title: 'Please confirm you want to rematch this statement?',
        //     size: 'lg',
        //     buttonSize: 'sm',
        //     okVariant: 'success',
        //     okTitle: 'Yes',
        //     cancelTitle: 'No',
        //     footerClass: 'p-2',
        //     hideHeaderClose: false,
        //     centered: true
        // })) {
        //     this.bankingslines.busy = true

        //     let variables = {
        //         account_id: this.item.id,
        //     }
        //     const response = await this.$apollo.mutate({
        //         mutation: gql`
        //             mutation bankingslines_rematch ($account_id:String) {
        //                 bankingslines_rematch (account_id: $account_id) {
        //                     id
        //                 }
        //             }
        //             `,
        //         variables,
        //     });

        //     this.bankingslines.busy = false
        // } else {
        //     this.bankingslines.busy = false
        // }

        // await this.bankingslines_load(0);

        // },
        async bankingslines_removeandredo(ss) {

            if (await this.$bvModal.msgBoxConfirm('Data is automatically matched against the Backoffice.', {
                title: 'Please confirm you want to Remove and Redo this statement line?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                this.bankingslines.busy = true

                let state = this.bankingslines;
                state.busy = true
                let variables = {
                    rows: this.cleanit(ss),
                };
                console.log(variables)
                try {
                    const response = await this.$apollo.mutate({
                        mutation: gql`
                        mutation bankingslines_removeandredo(
                            $rows: [BankingLine_input]               
                        ) {
                            bankingslines_removeandredo (rows: $rows) {
                                id
                            }
                        }
                        `,
                        variables,
                    });
                    this.message = "<span class='text-primary'>Saved it.</span>";
                } catch (error) {
                    this.message = "<span class='text-danger'>" + error.message + "</span>";
                }


                this.bankingslines.busy = false
            } else {
                this.bankingslines.busy = false
            }

            await this.bankingslines_load(0);

        },
        async bankingslines_invoicing(ss) {

            let accountno = this.item.accountno
            let title = 'Please confirm you want to send the ' + accountno + ' statement to charges?'
            let confirm = 'Data is automatically published to charges in a pending state.'

            let state = this.bankingslines;

            switch (accountno) {
                case "SVPCONFU":
                case "SVPCONF":
                case "BCARDCONF":
                case "WBAMEX":
                case "BLACKLANE":
                    if (await this.$bvModal.msgBoxConfirm(confirm, {
                        title,
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })) {
                        state.busy = true

                        // ACTION HERE
                        state.busy = true

                        let variables = {
                            account_id: this.item.id,
                        };
                        // DO SOMETHING
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                            mutation bankingslines_inventory ($account_id:String) {
                                bankingslines_inventory(account_id: $account_id)
                            }
                            `,
                            variables,
                        });

                        this.$store.dispatch("xhold");
                        this.$store.dispatch("ghold");
                        this.$store.dispatch("chold");
                    }
                    break;

                // case "SVPCONF":
                // case "BCARDCONF":
                //     if (await this.$bvModal.msgBoxConfirm(confirm, {
                //         title,
                //         size: 'lg',
                //         buttonSize: 'sm',
                //         okVariant: 'success',
                //         okTitle: 'Yes',
                //         cancelTitle: 'No',
                //         footerClass: 'p-2',
                //         hideHeaderClose: false,
                //         centered: true
                //     })) {

                //         state.busy = true

                //         let variables = {
                //             account_id: this.item.id,
                //         };
                //         // DO SOMETHING
                //         const response = await this.$apollo.mutate({
                //             mutation: gql`
                //         mutation bankingslines_conferma ($account_id:String) {
                //             bankingslines_conferma(account_id: $account_id)
                //         }
                //         `,
                //             variables,
                //         });

                //         this.$store.dispatch("chold");
                //     }
                //     break;
            }



            state.busy = false

            this.action_tab = 0

        },
        async bankingslines_fixit(ss) {

            let state = this.bankingslines;
            state.busy = true
            let variables = {
                rows: this.cleanit(ss),
            };
            console.log(variables)
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_fixit(
                            $rows: [BankingLine_input]               
                        ) {
                            bankingslines_fixit (rows: $rows) {
                                id
                            }
                        }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            state.busy = false
            await this.bankingslines_load(0);
        },
        async bankingsimports_load(offset, limit, page) {

            if (!this.item.id) { return }
            let state = this.bankingsimports;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                account_id: this.item.id,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query bankingsimports (
                        $offset: Int
                        $limit: Int         
                        $account_id: String             
                        ) {
                            bankingsimports (
                            offset: $offset
                            limit: $limit
                            account_id: $account_id                                            
                        ) {
                            id
                            url
                            size
                            lines
                            imported
                            type
                            start_at
                            end_at
                            data
                            account_id
                            unmatched
                            created_at
                            created_by
                            updated_by
                            updated_at
                            rows
                        }
                        }
                    `,
                    variables,
                });

                // if (limit == 0) {
                //     state.selected = response.data.bankingsimports
                // } else {
                //     state.items = []
                //     state.items = response.data.bankingsimports;
                // }

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.bankingsimports
                } else {
                    state.items = response.data.bankingsimports;
                }


            } catch (error) {
                console.log(error);
            }
            this.message = ""
            state.edit = false
            state.busy = false;
        },
        async bankingsimports_click(a, ss) {
            console.log('bankingsimports_click', a, ss)

            let state = this.bankingsimports;

            switch (a) {
                case "selectall":
                    break;
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.bankingsimports_load(0);
                    break;
                case "filter":
                    state.filtershow = !state.filtershow;
                    break;
                case "discard":
                    this.errormessage = ""
                    this.component = null
                    await this.bankingsimports_load(0)
                    break;
                case "go":
                    this.errormessage = ""
                    await this.bankingsimports_load(0)
                    break;
                case "add":
                    state.item = {
                        amount: "0",
                        account_id: this.item.id
                    }
                    state.edit = !state.edit
                    break;
                case "edit":
                    state.edit = !state.edit
                    break;
                case "delete":
                    await this.bankingsimports_delete(ss)
                    break;
                case "rename":
                    if (ss.length > 0) {
                        state.item = { ...ss[0] }
                    }
                    state.rename = !state.rename
                    break;
                case "import":
                    this.fileUpload = null
                    this.suggestedname = ""
                    state.importshow = !state.importshow
                    break;
                case "saveas":
                    await this.bankingsimports_saveas(ss);
                    break;
                case "redo":
                    await this.bankingsimports_redo(ss);
                    break;
                case "check":
                    this.errormessage = ""
                    await this.bankingsimports_check(ss);
                    break;
                case "reorder":
                    await this.bankingsimports_reorder(ss);
                    break;
                case "remt":
                    this.component = "BankingsREMT";
                    break;
                case "pending":
                    await this.bankingsimports_pending(ss)
                    break;

            }
        },
        async bankingsimports_select(ss, tools) {

            let state = this.bankingsimports;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "import", "download", "add", "reorder", "remt"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "saveas", "rename"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm", "redo", "check", "pending"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });

                if (state.selected.length > 0) {
                    state.item = state.selected[0]  // WHAT YOU SELECTED

                    let v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
                    if (state.item.date_at != 'NaN') {
                        v = this.$moment.unix(state.item.date_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    }
                    state.datefor_date_at = { startDate: v, endDate: v }
                } else {
                    state.item = {}
                }
            }
        },
        async bankingsimports_save(ss) {

            let state = this.bankingsimports;
            state.busy = true
            let variables = {
                rows: this.cleanit(ss),
            };
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingsimports_save(
                            $rows: [BankingImport_input]               
                        ) {
                            bankingsimports_save(rows: $rows) {
                            id
                            }
                        }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            state.busy = false
            await this.bankingsimports_load(0);

        },
        async bankingsimports_delete(ss) {

            let state = this.bankingsimports;
            state.busy = true
            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingsimports_delete($rows: [BankingImport_input]) {
                            bankingsimports_delete(rows: $rows) {
                            id
                            }
                        }
                        `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }
            state.busy = false
            await this.bankingsimports_load(0);
            await this.load()
        },
        async bankingsimports_pending(ss) {

            let state = this.bankingsimports;

            if (await this.$bvModal.msgBoxConfirm('Reset to Pending?', {
                title: 'Please confirm you want to reset the status of this to Pending?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                state.busy = true

                let rows = [];
                ss.forEach(function (v) {
                    rows.push({ id: v.id });
                });

                let variables = {
                    rows,
                };

                try {
                    const response = await this.$apollo.mutate({
                        mutation: gql`
                            mutation bankingsimports_pending($rows: [BankingImport_input]) {
                                bankingsimports_pending(rows: $rows) {
                                    id
                                }
                            }
                            `,
                        variables,
                    });
                } catch (error) {
                    console.log(error);
                }
            } else {
                state.busy = true
            }
            await this.bankingsimports_load(0);
            await this.load()
        },
        async bankingsimports_import() {

            console.log('bankingsimports_click')

            if (!this.item.id) { return }

            let state = this.bankingsimports;
            state.importshow = false

            this.errormessage = ""

            state.busy = true

            if (this.importoptions.includes('usesuggested')) {
                this.fileUpload.name = this.suggestedname
            }
            let variables = {
                account_id: this.item.id,
                data: JSON.stringify(this.fileUpload),
                options: JSON.stringify(this.importoptions)
            };


            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_import($account_id: String, $options:String, $data: String) {
                            bankingslines_import(account_id:$account_id, options:$options, data: $data) 
                        }
                    `,
                    variables,
                });
                this.message = "<span class='text-primary'>Imported it.</span>";


            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
                this.errormessage = error.message
            }

            try {
                variables = {
                    account_id: this.item.id,
                }
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_match ($account_id:String) {
                            bankingslines_match (account_id: $account_id) 
                        }
                        `,
                    variables,
                });
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
                this.errormessage = error.message
            }

            state.busy = false
            await this.bankingsimports_load(0);
            await this.load()

        },
        async bankingsimports_rename() {

            let state = this.bankingsimports;
            console.log('bankingsimports_rename', state.newname, state.item)

            let variables = {
                rows: [
                    {
                        id: state.item.id,
                        url: state.newname.toUpperCase()
                    }
                ]
            }
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingsimports_save(
                            $rows: [BankingImport_input]               
                        ) {
                            bankingsimports_save(rows: $rows) {
                            id
                            }
                        }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            state.newname = ""
            state.rename = false

            state.busy = false

            await this.bankingsimports_load(0);

        },
        async bankingsimports_saveas(ss) {
            this.busy = true;
            let variables = {
                id: ss[0].id,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query bankingsimports($id: String) {
                bankingsimports(id: $id) {
                id
                data
              }
            }
          `,
                    variables,
                });
                if (response.data.bankingsimports.length > 0) {
                    if (response.data.bankingsimports[0].data) {
                        this.fileUpload = JSON.parse(response.data.bankingsimports[0].data);
                        await this.fileUpload_view();
                    }
                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async bankingsimports_redo(ss) {

            console.log('bankingsimports_redo')
            let state = this.bankingsimports;
            state.importshow = false

            state.busy = true

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });
            rows = rows.map(o => ({ ...o, account_id: this.item.id }))

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_redo($rows: [BankingImport_input]) {
                            bankingslines_redo(rows:$rows) 
                        }
                    `,
                    variables,
                });
                this.message = "<span class='text-primary'>Redone it.</span>";


            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            state.busy = false

            await this.bankingsimports_load(0);

        },
        async bankingsimports_check(ss) {

            let state = this.bankingsimports;
            state.importshow = false

            state.busy = true

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });
            rows = rows.map(o => ({ ...o, account_id: this.item.id }))

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_check($rows: [BankingImport_input]) {
                            bankingslines_check(rows:$rows) 
                        }
                    `,
                    variables,
                });

                if (response.data.bankingslines_check.length == 0) {
                    this.errormessage = "Checked it. All BSP refs have been loaded and are on the statement.";
                } else {
                    this.errormessage = "Checked it. Please use 'Redo', missing BSP refs found.\n" + response.data.bankingslines_check;
                }

            } catch (error) {
                this.errormessage = error.message;
            }

            state.busy = false

            await this.bankingsimports_load(0);

        },

        async bankingsimports_reorder(ss) {

            console.log('bankingsimports_reorder')
            let state = this.bankingsimports;
            state.importshow = false

            state.busy = true

            let variables = {
                account_id: this.item.id
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
            mutation bankingsimports_reorder($account_id: String) {
                bankingsimports_reorder(account_id:$account_id) 
            }
        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Reordered it.</span>";


            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            state.busy = false
            // await this.bankings_load(this.account_id)
            await this.bankingsimports_load(0);

        },
        bsp_pretty(item) {
            let result = ""
            result += item.slice(0, 3)
            result += " "
            result += item.slice(3, 11)
            result += " "
            result += item.slice(11, 13)
            result += " "
            result += item.slice(13, item.length - 13)
            return result
        },

        async bsp_datareference(item) {

            let result = ""

            let code = item.slice(0, 3) + item.slice(11, 13)

            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query setup_bspdatareferences (
                        $code: String             
                        ) {
                            setup_bspdatareferences (
                                code: $code           
                        ) {
                            sort
                            description
                            reference
                            status
                            type
                            start
                            notes
                            }
                        }
                        `,
                    variables: {
                        code,
                    }
                })

                result += "<div class='text-center w-500px bg-black pt-3 pb-5 mt-n1 mb-n1'>"
                result += response.data.setup_bspdatareferences[0].description
                result += "<table align='center' >"
                result += "<tr>"
                result += "<th class='px-2'>El.</th>"
                result += "<th class='px-2' style='width:auto'>Element Description</th>"
                result += "<th class='px-2'>Reference</th>"
                result += "<th class='px-2'>Status</th>"
                result += "<th class='px-2'>Type</th>"
                result += "<th class='px-2'>Start</th>"
                result += "</tr>"
                for (var i = 1; i < response.data.setup_bspdatareferences.length; i++) {
                    let table = response.data.setup_bspdatareferences[i]
                    result += "<tr>"
                    result += "<td>" + table.sort + "</td>"
                    result += "<td>" + table.description + "</td>"
                    result += "<td>" + table.reference + "</td>"
                    result += "<td>" + table.status + "</td>"
                    result += "<td>" + table.type + "</td>"
                    result += "<td>" + table.start + "</td>"
                    result += "</tr>"
                }

                result += "</table>"

                if (response.data.setup_bspdatareferences[0].notes) {
                    result += "<p class='small text-secondary text-left mt-2 mx-5'>" + response.data.setup_bspdatareferences[0].notes.split(". ").join(".</br>") + "</p>"
                }
                result += "</div>"
                this.bsphelp = result

            } catch (error) {
                console.log(error);
            }

            return
        },
        async bankingslines_bspsummary() {
            console.log('bankingslines_bspsummary', this.bspyear)

            let state = this.bspsummary;
            state.busy = true

            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query bankingslines_bspsummary (
                        $year: String             
                        ) {
                            bankingslines_bspsummary (
                                year: $year           
                        ) {
                            label
                            ap_1
                            ap_2
                            ap_3
                            ap_4
                            ap_5
                            ap_6
                            ap_7
                            ap_8
                            ap_9
                            ap_10
                            ap_11
                            ap_12
                        }
                        }
                        `,
                    variables: {
                        year: this.bspyear,
                    }
                })

                // result += "<h6 class='strong'>BSP Summary for " + this.bspyear + "</h6>"
                // result += "<table align='center' class='bspsummary table-striped' >"
                // result += "<tr>"
                // result += "<th>&nbsp;</th>"
                // for (var i = 0; i < response.data.bankingslines_bspsummary.length; i++) {
                //     result += "<th>" + response.data.bankingslines_bspsummary[i].period + "</th>"
                // }
                // result += "</tr>"

                // let fields = ["fare", "tax", "efco", "tmfa"]
                // for (var i = 0; i < fields.length; i++) {
                //     result += "<tr>"
                //     result += "<td align='right' class='px-2'>" + fields[i] + "</td>"
                //     for (var k = 0; k < response.data.bankingslines_bspsummary.length; k++) {
                //         let row = response.data.bankingslines_bspsummary[k]
                //         result += "<td align='right'>" + row[fields[i]] + "</td>"
                //     }
                //     result += "</tr>"
                // }

                // result += "<tfoot>"
                // result += "<td class='text-right pl-2 text-primary strong'>amount</td>"
                // for (var i = 0; i < response.data.bankingslines_bspsummary.length; i++) {
                //     result += "<td class='text-primary strong'>" + response.data.bankingslines_bspsummary[i].amount + "</td>"
                // }
                // result += "</tfoot>"

                // result += "</table>"

                // this.bspsummary1 = result
                //  for (var i = 0; i < response.data.bankingslines_bspsummary.length; i++) {
                //  }
                // this.bspsummary.fields
                if (response.data.bankingslines_bspsummary.length > 0) {
                    let header = response.data.bankingslines_bspsummary[0];
                    for (var i = 0; i < state.fields.length; i++) {
                        if (header[state.fields[i].key]) {
                            state.fields[i].label = header[state.fields[i].key]
                        }
                    }
                }

                state.items = []
                for (var i = 1; i < response.data.bankingslines_bspsummary.length; i++) {
                    state.items.push(response.data.bankingslines_bspsummary[i])
                }

            } catch (error) {
                console.log(error);
            }
            state.busy = false
        },
        async bspsummary_click(a, ss) {
            console.log('bspsummary_click', a, ss)

            let state = this.bspsummary;

            switch (a) {
                case "selectall":
                    break;
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.bankingslines_bspsummary(0);
                    break;
                case "filter":
                    state.filtershow = !state.filtershow;
                    break;
                case "discard":
                    this.errormessage = ""
                    this.component = null
                    await this.bankingslines_bspsummary(0)
                    break;
                case "go":
                    this.errormessage = ""
                    await this.bankingslines_bspsummary()
                    break;
            }
        },
        async bspsummary_select(ss, tools) {

            let state = this.bspsummary;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "clipboard", "download", "add"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "saveas", "rename"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm", "redo", "check"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });

                // if (state.selected.length > 0) {
                //     state.item = state.selected[0]  // WHAT YOU SELECTED

                //     let v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
                //     if (state.item.date_at != 'NaN') {
                //         v = this.$moment.unix(state.item.date_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                //     }
                //     state.datefor_date_at = { startDate: v, endDate: v }
                // } else {
                //     state.item = {}
                // }
            }
        },

        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        resetModal() {
            this.name = ''
            this.nameState = null
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },
        async handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                return
            }
            // Push the name to submitted names
            // this.submittedNames.push(this.name)
            await this.bankingsimports_import()

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('import-file')
            })
        },
        back() {
            if (this.headerShow) {
                this.$router.back(-1)
            } else {
                this.$emit('discard')
            }
        },
    },
};
</script>

<style>
.courier .tooltip-inner {
    /* Removes the default max-width */
    max-width: 560px;
    font-family: 'Courier New', Courier, monospace;
}
</style>